export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Typography.vue?vue&type=template&id=dd10571e&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Styles/Typography.vue?vue&type=template&id=dd10571e&scoped=true&
// module id = null
// module chunks = 